import React, { useRef, useState } from "react";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import { Button } from "react-bootstrap";

const ChargeRegProp = () => {
  const [file, setFile] = useState(null);
  const [typeChrage, setTypeChrage] = useState("");
  const isSubmitDisabled = !file || !typeChrage;
  const fileInputRef = useRef(null);


  const handleTypeChrageChange = (e) => {
    setTypeChrage(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }

    try {
      const response = await CreacionTitulosService.postPropsRegisters(file, typeChrage);
      console.log(response);
      alert("Archivo enviado con éxito");
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      alert("Error al enviar el archivo");
    }
  };

  return (
    <div className="mt-5 shadow-top">
      <div className="p-4 shadow">
        <h5 className="fw-semibold mb-4">Carga Registro de la Propiedad en DB</h5>
        <div className="mb-3 d-flex flex-column">
          <label className="form-label mb-2">Selecciona una categoría:</label>
          <select
            className="custom-select"
            value={typeChrage}
            onChange={handleTypeChrageChange}
          >
            <option value="" disabled>Selecciona una opción</option>
            <option value="inmueble">Completa</option>
            <option value="comercio">Parcial</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label mb-2">
            Selecciona un archivo:
          </label>

          <div className="custom-file-wrapper">
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="custom-file-input"
              id="fileRegister"
            />

            <label htmlFor="fileRegister" className="custom-file-button">
              Seleccionar
            </label>

            <span
              className={`custom-file-text ${!file ? "no-file" : ""}`}
            >
              {file ? file.name : "Ningún archivo seleccionado"}
            </span>
          </div>
        </div>
        <div>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Enviar archivo
          </Button>
        </div>
      </div>


    </div>
  );
};

export default ChargeRegProp;